import React from 'react';

import style from './AboutUs.module.css';
import GearBig from '../../../images/GearBig.png';
import GearSmall from '../../../images/GearSmall.png';

const AboutUs = () => {
  return (
    <>
      <div className={style.aboutUsContainer} id="about">
        <div className={style.headingGear}>
          <h1>About Us</h1>
          <div className={style.gearContainer}>
            <img
              src={GearBig}
              alt="Big Gear"
              loading="lazy"
              decoding="async"
              className={style.gearBig}
              width="100"
              height="100"
            />
            <img
              src={GearSmall}
              alt="Small Gear"
              loading="lazy"
              decoding="async"
              className={style.gearSmall}
              width="60"
              height="60"
            />
          </div>
        </div>
        <div className={style.paragraphContainer}>
          <p>
            At <strong>Artemida Studio</strong>, we specialize in creating
            custom <strong>landing pages and corporate websites</strong> that
            help businesses establish a strong online presence. Our mission is
            to deliver modern, functional, and visually stunning solutions
            tailored to your brand's needs.
          </p>
          <p>
            By combining creativity, the latest technologies, and a personalized
            approach, we build websites that are not only aesthetically
            appealing but also fast, user-friendly, and fully responsive.
          </p>
          <p>
            Whether you need a high-converting <strong>landing page</strong> or
            a professional <strong>corporate website</strong>,
            <strong>Artemida Studio</strong> is here to bring your vision to
            life with high-quality, custom solutions.
          </p>
          <p>
            Choose professionalism and creativity – let’s build your perfect
            website together!
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
